/**
 * String-literal unions shared across entities and API payloads. Each is annotated with
 * where it actually comes from — a `Literal[...]` in a Pydantic schema (backend-enforced)
 * vs. a plain `String` column (backend-permissive, values here are the documented
 * convention only). Treat the latter category as UI hints / autocomplete, not a runtime
 * guarantee the backend will reject anything else — it won't.
 */
export const APP_ROLES = [
    "OWNER",
    "BRANCH_MANAGER",
    "ACCOUNTANT",
    "TELLER",
    "ECOM_MGR",
];
export const BUSINESS_TYPES = ["PHARMACY", "RETAIL", "SUPERMARKET", "AGRI"];
//# sourceMappingURL=enums.js.map